import isEmpty from "lodash/isEmpty"
import get from "lodash/get"
import axios from "axios"
import URITemplate from "urijs/src/URITemplate"
import { urls } from "utils-lib/builds"
import dayjs from "utils-lib/date"
import {
  GET_SE_CAPACITY_PLANNER_PENDING,
  GET_SE_CAPACITY_PLANNER_FAILED,
  GET_SE_CAPACITY_PLANNER_FULFILLED,
} from "constants-lib/actionTypes"

export const pendingAC = () => ({
  type: GET_SE_CAPACITY_PLANNER_PENDING,
})

export const failedAC = (data) => ({
  type: GET_SE_CAPACITY_PLANNER_FAILED,
  payload: data,
})

export const fulfilledAC = (data) => ({
  type: GET_SE_CAPACITY_PLANNER_FULFILLED,
  payload: data,
})

export const getSECapacityPlanner = () => (dispatch, getState) => {
  const state = getState()
  const template = URITemplate(urls.url.SE_CAPACITY_PLANNER)
  const apiKey = URITemplate(urls.apiKey.GUEST.SE_CAPACITY_PLANNER)
  const lang = get(state, `siteLanguage.language`, ``)

  const startDate = dayjs().add(0, `days`).format(`YYYY-MM-DD`)
  const endDate = dayjs().add(90, `days`).format(`YYYY-MM-DD`)
  const zones = get(state, `onlineProducts.initialEcommercePricing.zones`, [])
  const siteId = findMatchingSiteId(zones)
  const url = template.expand({
    fromDate: startDate,
    toDate: endDate,
    mode: `REGULAR_PICKUP`,
    siteId,
    lob: `Rolloff`,
    lang,
  })
  const config = {
    url,
    method: `get`,
    headers: {
      "Content-Type": `application/json`,
      apiKey: apiKey.expression,
    },
  }

  dispatch(pendingAC())
  return axios(config)
    .then((response) => {
      if (response.status === 204 || isEmpty(response.data)) {
        dispatch(
          fulfilledAC({
            AvailableDates: [],
            from_date: startDate,
            to_date: endDate,
          }),
        )
        return response.data
      }
      dispatch(fulfilledAC(response.data))
      return response.data
    })
    .catch((error) => {
      dispatch(failedAC(error.response.status))
      return error
    })
}

/**
 * Finds the matching site ID based on the given zones and business lines.
 * @param {Array} zones - The array of zones to search through.
 * @returns {string} - The matching site ID, or an empty string if not found.
 */
export const findMatchingSiteId = (zones) => {
  const businessLines = ["ROLLMSW", "ROLLCONST", "ROLLREC"]
  const siteId = get({ zones }, "zones[0].site_id", "")

  const matchingZone = businessLines.reduce(
    (acc, line) =>
      acc ||
      zones.find(
        (zone) =>
          zone.type_indicator_code === 1 &&
          zone.contract_type_code === 1 &&
          zone.line_of_business === line,
      ),
    null,
  )

  return matchingZone ? matchingZone.site_id : siteId
}
